import { useDisclosure } from "@chakra-ui/react"
import {useState, createContext, useRef } from "react"


export let MyExternalContext = createContext()   //This is the minor that gets imported in other componenets. (This is the part that get imported and used in componenets)

function MyExternalContextProvider({children}){   // Children here means children components



    let [subscription, setSubscription] = useState([])
    let [watchLater, setWatchLater] = useState([])
    let [likedVideos, setLikedVideos] = useState([])
    let [playlist, setPlaylist] = useState([])
    let [playlistItem, setPlaylistItem] = useState([])
    let [watchLNextPage, setWatchLNextPage] = useState(null)
    let [likeVidNextPage, setLikeVidNextPage] = useState(null)
    let [playlistNextPage, setPlaylistNextPage] = useState(null)
    let [playlistCountSize, setPlaylistCountSize] = useState({count:"", size:""})
    let {isOpen:isOpenUploadVideo, onClose:onCloseUploadVideo, onOpen:onOpenUploadVideo} = useDisclosure()
    let [captureInfo, setCaptureInfo] = useState()
    let [doneUpdating, setDoneUpdating] = useState()
    let [step, setStep] = useState(1)
    let [notifications, setNotifications] = useState([])
    let [isOpenNotification, setIsOpenNotification] = useState(false)
    let clickWatchLaterRef = useRef()
    let unClickWachLaterRef = useRef()
    


    
    //For external API
    //let [isMini, setIsMini] = useState(false)
    let [externalUrl, setExternalUrl] = useState()
    let [albumImage, setAlbumImage] = useState()
    let [backHistory, setBackHistory] = useState("Test external context is working")
    

   
    // Spread opearator can also be used for object eg. {...extra}. Creates a shallow copy without mutating the original
    const extra = {
        watchLNextPage, setWatchLNextPage, likeVidNextPage,setLikeVidNextPage,
        playlistNextPage, setPlaylistNextPage, playlistItem, setPlaylistItem,
        clickWatchLaterRef, unClickWachLaterRef, isOpenUploadVideo, onOpenUploadVideo, 
        onCloseUploadVideo, step, setStep, captureInfo, setCaptureInfo,doneUpdating,setDoneUpdating,
        playlistCountSize, setPlaylistCountSize,  isOpenNotification, setIsOpenNotification, notifications, setNotifications
    }

    return(
        <div>
            <MyExternalContext.Provider value={{subscription, setSubscription, watchLater, setWatchLater, likedVideos, setLikedVideos, playlist, setPlaylist, ...extra}}>
                {children}
            </MyExternalContext.Provider>
            
        </div>
    )
}





export default MyExternalContextProvider   // This is the major that gets use in App.js